export const BACKGROUND_IMAGES = [
	"david-billings-__I-gX-cnd8-unsplash (1).jpg",
	"dvir-adler-uSj_ce8vtyE-unsplash.jpg",
	"getty-images-kjXpmeqUYsU-unsplash.jpg",
	"joshua-earle-4UexhWLVcnY-unsplash.jpg",
	"joshua-earle-Ld583Sij9-E-unsplash.jpg",
	"joshua-earle-oz1GKlRWab4-unsplash.jpg",
	"joshua-earle-PUHfSAQtJeo-unsplash.jpg",
	"joshua-earle-zYT8Ih3iPGA-unsplash (1).jpg",
	"marc-najera-JWAAgQSbq44-unsplash.jpg",
	"patrick-tomasso-ekIyE1QXyL4-unsplash.jpg",
	"pine-watt-2Hzmz15wGik-unsplash.jpg",
	"tegan-mierle-ioyEITUD2G8-unsplash.jpg",
	"xan-griffin-eA2t5EvcxU4-unsplash.jpg",
	"jeffrey-f-lin-oc8m9Cj8dsc-unsplash.jpg",
	"hudson-hintze-vpxeE7s-my4-unsplash.jpg",
	"helena-cook-5ed6i2hXeZk-unsplash.jpg",
	"getty-images-Zp1ZAw0tusg-unsplash.jpg",
	"getty-images-aVRkLOFVNK4-unsplash.jpg",
];

export function getRandomBackground() {
	const randomIndex = Math.floor(Math.random() * BACKGROUND_IMAGES.length);
	return `/img/random-backgrounds/${BACKGROUND_IMAGES[randomIndex]}`;
}
